import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

const $ = window.$ = window.jQuery = require('jquery');
$('body').addClass('loaded');
require('lightbox2');

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
